import { styled } from 'styled-components';
import { breakpoint, spacing } from 'styles/helpers';

export const Wrapper = styled.div`
  ${breakpoint.mobile} {
    padding: ${spacing.s} ${spacing.m};
  }
`;
